export const common = {
  lockIconAlt: "Lock icon",
  messageConceive: "Text now",
  takeSurvey: "this survey",
  or: "or",
  plans: {
    plus: "Conceive Plus",
    premium: "Conceive Premium",
    weight_loss: "Conceive GLP-1 Fertility Program",
    short: {
      plus: "Plus",
      premium: "Premium",
      weight_loss: "GLP-1",
    },
  },
  conversationalIntervals: {
    "1-month": "monthly",
    "3-months": "every 3 months",
    "6-months": "every 6 months",
    "12-months": "annually",
  },
};
